import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

import { GameService } from '../services/game.service';
import { Level, ApplicationText } from '../_models/model';
import { AudioPlayerService } from '../services/audio-player.service';

@Injectable()
export class ApplicationTextResolver implements Resolve<ApplicationText[]> {
  constructor(private audioPlayerService: AudioPlayerService) {


  }

  resolve(route: ActivatedRouteSnapshot) {
    // console.log('application-text resolver called');

    // TODO: redirect to error page on not found?
    return this.audioPlayerService.loadText();
  }
}
